
import FacebookIcon from "Assets/SocialMediaIconSvg/facebook.svg"
import InstagramIcon from "Assets/SocialMediaIconSvg/instagram.svg"
import XIcon from "Assets/SocialMediaIconSvg/x.svg"
import LinkedinIcon from "Assets/SocialMediaIconSvg/linkedin.svg"
import YoutubeIcon from "Assets/SocialMediaIconSvg/youtube.svg"
import PintrestIcon from "Assets/SocialMediaIconSvg/pintrest.svg"
import WhatsappIcon from "Assets/SocialMediaIconSvg/whatsapp.svg"
import GoogleMapIcon from "Assets/SocialMediaIconSvg/google-maps.svg"
import CalendyIcon from "Assets/SocialMediaIconSvg/calendy.svg"
import RedditIcon from "Assets/SocialMediaIconSvg/reddit.svg"
import TiktokIcon from "Assets/SocialMediaIconSvg/tiktok.svg"
import BuymeacofeeIcon from "Assets/SocialMediaIconSvg/bmc.svg"





export const socialMediaLinksData = [

  { name: "facebook", icon: FacebookIcon },
  { name: "instagram", icon: InstagramIcon },
  { name: "x", icon: XIcon },
  { name: "linkedin", icon: LinkedinIcon },
  { name: "youtube", icon: YoutubeIcon },
  { name: "pintrest", icon: PintrestIcon },
  { name: "whatsapp", icon: WhatsappIcon },
  { name: "googlemap", icon: GoogleMapIcon },
  { name: "calendly", icon: CalendyIcon },
  { name: "reddit", icon: RedditIcon },
  { name: "tiktok", icon: TiktokIcon },
  { name: "buymeacoffe", icon: BuymeacofeeIcon },
];
